import Language from "@/types/Models/Settings/Language";

const German: Language = {
    settings: {
        title: "Einstellungen",
        theme: {
            title: "Theme",
            placeholder: "Theme auswählen",
            themes: {
                dark: "Dunkel",
                light: "Hell",
            },
        },
        language: {
            title: "Sprache",
            placeholder: "Sprache auswählen",
        },
        mandant: {
            title: "Mandant",
            placeholder: "Mandant auswählen",
        },
        division: {
            title: "Abteilung | Abteilungen",
            placeholder: "nicht zugewiesen",
        },
        logout: {
            title: "abmelden",
        },
        notifications: {
            saveSuccess: "Einstellungen @:notifications.save.success",
            saveInfo: "",
            saveError: "",
            logout: "Erfolgreich abgemeldet",
        },
    },
    maintenance: {
        title: "Wartungsarbeiten",
        description: "Bitte versuchen Sie es in ein paar Minuten erneut",
    },
    modules: {
        zew: {
            moduleDescription: {
                title: "Zeitwirtschaft",
                fullTitle: "@:general.module @:modules.zew.moduleDescription.title",
            },
            currentTimeRecord: {loggedIn: "angemeldet seit:", loggedOut: "nicht angemeldet"},
            signIn: "kommen",
            signOut: "gehen",
            checkedIn: "eingestempelt",
            checkedOut: "ausgestempelt",
            currently: "Momentan:",
            timeRecord: {
                hours: "Stunden", 
                saldo: "Saldo", 
                holidaysSaldo: "Feriensaldo", 
                mutMessage: "Nachricht",
                holidays: "Ferien:",
                sick: "Krank:",
                asOf: "per",
            },
            absence: {
                name: "Absenz | Absenzen",
                type: "Typ",
                start: "Datum von",
                end: "Datum bis",
                message: "Beschreibung",
                hours: "Stunden",
                entireDay: "Ganztägig",
                supervisor: "Vorgesetzte",
                create: "@:modules.zew.absence.name @:actions.create",
                overview: "Absenz Übersicht",
                form: {
                    dateRequired: "Datum wird benötigt",
                    typeRequired: "Typ wird benötigt",
                    endDateBeforeStartDate: "Enddatum ist vor dem Startdatum",
                    descriptionRequired: "Eine Beschreibung wird benötigt",
                    supervisorRequiredForVisa: "Vorgesetzte Person wird für das Visum benötigt",
                    absenceCreateError: "Absenz konnte nicht erstellt werden",
                    absenceCreated: "Absenz erstellt",
                    endTimeKnown: "Endzeit bekannt?",
                },
                states: {
                    requested: "@:modules.zew.absence.name beantragt",
                    approved: "@:modules.zew.absence.name bewilligt",
                    rejected: "@:modules.zew.absence.name abgelehnt",
                },
                request: {
                    messageRequired: "Eine Mitteilung wird benötigt",
                    messageToLong: "Nachricht ist zu lang",
                    absenceApproved: "Absenz wurde bestätigt",
                    absenceRejected: "Absenz wurde abgelehnt",
                    absenceEdit: "Absenz bearbeiten",
                    overview: "Übersicht",
                    createdBy: "Erstellt von",
                },
            },
            expense: {
                name: "Spesen | Spesen",
                type: "Typ",
                date: "Datum",
                amount: "Betrag",
                description: "Beschreibung",
                currency: "Währung",
                supervisor: "Vorgesetzte",
                create: "@:modules.zew.expense.name @:actions.create",
                states: {
                    approved: "Spesenabrechnung bewilligt",
                    rejected: "Spesenabrechnung abgelehnt",
                    requested: "Spesenabrechnung beantragt",
                },
                form: {
                    dateRequired: "Datum wird benötigt",
                    typeRequired: "Typ wird benötigt",
                    expenseRequired: "Betrag wird benötigt",
                    currencyRequired: "Währung wird benötigt",
                    descriptionRequired: "Eine Beschreibung wird benötigt",
                    supervisorRequiredForVisa: "Vorgesetzte Person wird für das Visum benötigt",
                    attachmentRequired: "Anhang wird benötigt",
                    absenceCreateError: "Absenz konnte nicht erstellt werden",
                    expenseReportCreateError: "Spesenabrechnung konnte nicht erstellt werden",
                    expenseReportCreated: "Spesenabrechnung erstellt",
                    expenseReportNotCreated: "Spesenabrechnung nicht erstellt",
                    expenseInvalid: "Betrag ungültig"
                },
            },
        },
        todo: {
            moduleDescription: {
                title: "ToDo | ToDos",
                fullTitle: "@:general.module @:modules.todo.moduleDescription.title",
            },
            sortBy: {
                user: "Person",
                company: "Firma",
                group: "Team",
                dueDate: "Fälligkeitsdatum",
                inDate: "Erstellungsdatum",
                status: "Status",
                priority: "Priorität"
            },
            task: {
                title: "Teilaufgabe | Teilaufgaben",
                report: "Rapport",
                finishReport: "Rapport abschliessen",
                reportCacheSaved: "Entwurf gespeichert",
                reportCacheCreated: "Entwurf erstellt",
                draft: "Entwurf",
                titleShort: "Aufgabe | Aufgaben",
                infoMessage: "Vorgang, Info",
                errorMessage: "Fehler / Meldung des Kunden",
                assignedSybUser: "Zuständige Person",
                secondaryUsers: "Sekundäre Personen",
                inSybUser: "Todo erstellt von",
                assignedTitle: "Zuordnung",
                createTask: "@:modules.todo.task.title @:actions.create",
                taskSaved: "@:modules.todo.task.title gespeichert",
                editTask: "@:modules.todo.task.title @:actions.edit",
                realStarttime: "Effektive Startzeit:",
                realEndtime: "Effektive Endzeit:",
                realTimeTotal: "Effektive Stunden:",
                roundedTimeTotal: "Gerundete Stunden:",
                entity: {
                    title: "Titel",
                    comment: "Kommentar",
                    date: "Datum",
                    hasTime: "Zeit bekannt?",
                    startTime: "Zeit von",
                    endTime: "Zeit bis",
                    travel: "Anfahrt",
                    hours: "Aufwand in Stunden",
                    billingType: "Verrechnungsart",
                    collaborators: "Zusätzliche Mitarbeiter"
                }
            },
            log: {
                customerInformation: "Kundeninformationen",
                companyName: "Firma, Name",
                companyAddress: "Adresse",
                deliveryAddress: "Lieferadresse",
                contactInformation: "Kontaktdaten",
                telP: "Telefon Privat:",
                telG: "Telefon Geschäft:",
                infiniteScrollLoading: 'Weitere ToDos werden geladen...',
                infiniteScrollEOF: 'Keine weiteren ToDos',
            },
            documents: {
                title: "Dokument | Dokumente",
                createDocument: "Dokument hinzufügen",
                selectDocument: "Dokument auswählen",
                entity: {
                    title: "Dateiname",
                    keywords: "Schlüsselwörter",
                    file: "Datei",
                },
                attachments: {
                    fileRequired: "Datei wird benötigt",
                    attachmentRequired: "Anhang wird benötigt"
                }
            },
            other: {
                todoCount: "Anzahl ToDos: ",
                notDefined: "nicht definiert",
                backToMonthlyOverview: "Zurück zur Monatsübersicht"
            }
        }
    },
    general: {
        details: "Details",
        description: "Beschreibung",
        history: "History",
        module: "Modul",
        date: "Datum",
        start: "Beginn",
        end: "Ende",
        download: "Herunterladen",
        time: {
            title: "Zeit",
            days: "Tag | Tage",
            hours: "Stunde | Stunden",
            timeSpent: "Zeitaufwand"
        },
        attachment: {
            title: "Anhang",
            preview: {
                title: "Vorschau",
                loading: "@:general.attachment.preview.title wird geladen...",
                error: "@:general.attachment.preview.title konnte nicht geladen werden.",
            },
        },
    },
    transactions: {
        message: "Mitteilung",
        inProgress: "In Bearbeitung",
        approved: "Bewilligt",
        rejected: "Abgelehnt",
    },
    account: {
        welcomeBack: "Willkommen zurück",
        segments: {
            overview: "Übersicht",
            settings: "Einstellungen",
        },
        user: {
            password: {
                reset: "Passwort zurücksetzen",
                new: "neues Passwort",
                repeat: "Passwort wiederholen",
                lowerCaseRequired: "Mindestens 1 Kleinbuchstabe",
                upperCaseRequired: "Mindestens 1 Grossbuchstabe",
                numberRequired: "Mindestens 1 Zahl",
                specialCharacterRequired: "Mindestens 1 Sonderzeichen",
                minLengthRequired: "Mindestens 8 Zeichen lang",
                noMatch: "Passwort stimmt nicht überein"
            },
        },
        login: {
            emailRequired: "Email benötigt",
            emailInvalid: "Email ungültig",
            passwordRequired: "Passwort benötigt",
            noConnectionError: "Verbindung zum Server fehlgeschlagen",
            wrongCredentialsError: "Email oder Passwort falsch",
            loginSubmit: "anmelden",
            loginLoading: "Bitte warten...",
            contactSupport: "Support kontaktieren",
            problem: "Probleme?",
        },

    },
    actions: {
        exit: "schliessen",
        back: "zurück",
        save: "speichern",
        cancel: "abbrechen",
        create: "erstellen",
        read: "ansehen",
        update: "aktualisieren",
        edit: "bearbeiten",
        delete: "löschen",
        select: "auswählen",
        search: "suchen",
        sortBy: "Sortieren nach:",
        orderByDescAsc: "absteigend / aufsteigend",
        reject: "ablehnen",
        accept: "akzeptieren",
        dismiss: "schliessen",
        complete: "abschliessen",
        wait: "warten",
        confirm: "bestätigen",
        add: "hinzufügen",
        reset: "zurücksetzen",
        download: "herunterladen",
        assign: "zuweisen",
    },
    admin: {
        roles: {
            title: "Gruppe | Gruppen",
            cardTitle: "Berechtigungs- Gruppen",
            editTitle: "@:admin.roles.title bearbeiten",
            createTitle: "@:admin.roles.title erstellen",
            required: {
                nameRequired: "Name wird benötigt",
                lengthRequired: "Mindestens 3 Zeichen"
            },
            selectRole: {
                noRoleAvaiable: "Keine Berechtigungsgruppe vorhanden",
                createNewGroup: "Neue Gruppe erstellen",
            }
        },
        users: {
            title: "Person | Personen",
            cardTitle: "Personen",
            notifications: {
                success: "Person @:notifications.save.success",
            },
            mandantUserForm: {
                maxUserRequired: "MaxUser wird benötigt",
                maxUserRequiredLength: "Mindestens 2 Zeichen lang",
                roleRequired: "Berechtigungsgruppe wird benötigt",
            }
        },
        permissions: {
            title: "Berechtigung | Berechtigungen",
            deleteMessage: "Alle Personen, welche zu dieser Gruppe angehören, müssen anschliessend einer anderen Gruppe manuell zugewiesen werden. ",
            notifications: {
                success: "Berechtigungen @:notifications.save.success",
            },
        },
        divisions: {
            title: "Abteilung | Abteilungen",
            cardTitle: "Abteilungen verwalten",
            editTitle: "@:admin.divisions.title bearbeiten",
            createTitle: "@:admin.divisions.title erstellen",
            notifications: {
                success: "Abteilung @:notifications.save.success",
            },
            ccAbsences: {
                title: "CC Absenzmeldungen",
                helperText:
                    "Absenzmeldungen werden zusätzlich an diese E-Mail versendet. \nPerson auswählen oder manuell eine E-Mail eingeben.",
                selectPerson: "Person @:actions.select",
            },
            required: "Level wird benötigt",
            helperText: "Beispiel: Level 1 = Mitarbeitende, Level 2 = Vorgesetzte",
        },
        general: {
            selectManager: "Zuständige Person aus der Personalabteilung.",
        },
    },
    notifications: {
        page: {
            title: "Benachrichtigung | Benachrichtigungen",
            noNotifications: "Keine Benachrichtigung",
        },
        entity: {
            markAsUnread: {
                title: "als ungelesen markieren",
                error: "Benachrichtigung konnte nicht als 'ungelesen' markiert werden",
                success: "Benachrichtigung wurde als ungelesen markiert",
            },
        },
        save: {
            success: "erfolgreich gespeichert",
            info: "",
            error: "Fehler beim Speichern, bitte erneut versuchen",
        },
        delete: {
            success: "erfolgreich gelöscht",
            info: "",
            error: "Konnte nicht gelöscht werden, bitte erneut versuchen",
            errorDivision: "konnte nicht gelöscht werden - Personen sind bereits zugewiesen!",
            question: "wirklich löschen?",
        },
        update: {
            success: "Erfolgreich aktualisiert",
            denied: "Dieser Eintrag kann nicht mehr bearbeitet werden",
            error: "Fehler beim aktualisieren, bitte erneut versuchen",
        },
        app: {
            start: "Applikation wird gestartet",
        },
        api: {
            connectionFailed: "Verbindung fehlgeschlagen, versuchen Sie es später noch einmal",
            connectionRestored: "Verbindung wieder hergestellt...",
        },
        sync: {
            entity: {
                error: "Datensatz noch nicht synchronisiert. <br/> Bitte in einigen Minuten erneut versuchen",
            },
            module: {
                active: "Wird synchronisiert, bitte später erneut versuchen. <br/> Start: {content}",
                inactive: "Max Synchronisierungsfehler: <br/> Bitte Zeitwirtschaft überprüfen",
            },
        },
        auth: {
            accessDenied: "Zugriff auf diese Funktion ist gesperrt.",
        },
        google: {
            maps: {
                linkError: "Google-Maps-Link konnte nicht erstellt werden"
            }
        },
        download: {
            success: "erfolgreich heruntergeladen",
            error: "Datei konnte nicht heruntergeladen werden"
        }
    },
    form: {
        submit: {
            save: {
                waitText: "Wird gespeichert...",
            },
            delete: {
                waitText: "Wird gelöscht..."
            },            
            file: {
                notSupported: "Dieser Dateityp wird nicht unterstützt",
                imgTaken: "Bild erfolgreich aufgenommen",
                cameraAccessDenied: "Auf die Kamera konnte nicht zugegriffen werden",
                supportedFiles: "Unterstützte Dateiformate: ",
                saveImage: "Bild speichern",
                changeCamera: "Kamera wechseln",
                camera: "Kamera",
            },
        },
        blocks: {
            customer: {
                name: "Name",
                namePlaceholder: "Vorname Nachname angeben",
                street: "Strasse",
                streetPlaceholder: "Strasse angeben",
                location: "Ort",
                locationPlaceholder: "Ort angeben",
                contact: "Kontakt",
                contactPlaceholder: "Kontakt angeben",
                phonePrivate: "Telefon Privat",
                phoneBusiness: "Telefon Geschäft",
                phonePlaceholder: "Telefon angeben",
                email: "E-Mail",
                emailPlaceholder: "E-Mail angeben",
                deliveryAddress: "Lieferadresse",
                deliveryAddressPlaceholder: "Lieferadresse angeben",
            },
            image: {
                savedImage: "gespeichertes Bild",
                editEntry: "Eintrag bearbeiten",
                addEntry: "Eintrag hinzufügen",
                close: "Schliessen",
                description: "Beschreibung",
                save: "Speichern",
            },
            invoice: {
                amount: "Betrag",
                amountPlaceholder: "Betrag angeben",
                vat: "MWST-Satz",
                vatPlaceholder: "Wert in Prozent angeben",
                sumTotal: "Rechnungstotal",
                sumTotalPlaceholder: "Betrag angeben",
            },
            materials: {
                descriptionRequired: "Beschreibung benötigt",
                editEntry: "Eintrag bearbeiten",
                addEntry: "Eintrag hinzufügen",
                close: "Schliessen",            
            },
            reportInformation: {
                reportNumber: "Rapport-Nr.",
                customerNumber: "Kunden-Nr.",
                orderNumber: "Auftrags-Nr.",
                responsibleUser: "Zuständige Person",
                date: "Datum",
                done: "speichern",
                cancel: "abbrechen",
            },
            settings: {
                sendCustomerCopy: "Kopie an Kunde senden",
                addChecklistToCustomer: "Checkliste als Anhang mitsenden",
                customerMail: "E-Mail Adresse",
                customerMailPlaceholder: "E-Mail Adresse angeben",
                customerMailError: "E-Mail Adresse ungültig!",
            },
            tasks: {
                titleRequired: "Titel wird benötigt",
                titleMaxLengthError: "Titel zu lang",
                dateRequired: "Datum wird benötigt",
                notANumber: "Dies ist keine gültige Zahl",
                enterExpenseInHours: "Bitte einen Aufwand in Stunden angeben",
                editEntry: "Eintrag bearbeiten",
                addEntry: "Eintrag hinzufügen",
                close: "Schliessen",
                totalHours: "Total Stunden",
            }
        }        
    },
    tutorials: {
        title: "Anleitung",
        overview: "Übersicht",
        admin: {
            roles: {
                overview: {
                    firstDescription:
                        "Eine Berechtigungsgruppe wird verwendet, um den Zugriff auf die verschiedenen Funktionen in der Applikation zu regeln. In der Personenverwaltung kann anschliessend die erstellte Gruppe ausgewählt werden.",
                },
            },
            divisions: {
                overview: {
                    firstDescription:
                        "Erstellen Sie hier die Abteilungen in Ihrem Unternehmen. Wenn Ihre Mitarbeitende nicht in Abteilungen unterteilt sind, erstellen Sie eine für den gesamten Betrieb und fügen Sie die Mitarbeitenden anschliessend hinzu.",
                    secondDescription: "Die Abteilungen werden für die Absenzverwaltung benötigt.",
                },
            },
        },
    },
    alerts: {
        delete: {title: "Löschen bestätigen", message: "{content} wirklich löschen?"},
        reportDraft: {
            title: "Rapport im Zwischenspeicher",
            message: "Sie haben noch einen Rapport im Zwischenspeicher - den zuletzt bearbeiteten Stand laden?",
            otherToDoTitle: "Rapport-Entwurf für anderes ToDo",
            otherToDoMessage: "Im Zwischenspeicher liegt noch ein nicht abgeschlossener Rapport-Entwurf für ToDo «{otherToDo}» vor. Laden wechselt zu diesem ToDo. Verwerfen löscht den Entwurf und Sie erstellen einen neuen Rapport für «{currentToDo}»."
        }
    },
};

export default German;
